import { render, staticRenderFns } from "./PackageSettingSelect.vue?vue&type=template&id=365dc3ee"
import script from "./PackageSettingSelect.vue?vue&type=script&lang=js"
export * from "./PackageSettingSelect.vue?vue&type=script&lang=js"
import style0 from "./PackageSettingSelect.vue?vue&type=style&index=0&id=365dc3ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports